export const FRONTEND_PRODUCT_PATH_ID = 'frontend_product_path_id';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const GENDER = 'gender';
export const AVATAR = 'avatar';
export const PHONE = 'phone';
export const EMAIL = 'email';
export const STATE_OF_RESIDENCE = 'stateOfResidence';
export const PRODUCT_CODE = 'product_code';
export const PARAMS = 'params';
export const INVITE_CODE = 'invite_code';
export const COUPON_CODE = 'coupon_code';
export const WEBINAR1_DATE_TIME = 'webinar1_date_time';
export const WEBINAR2_DATE_TIME = 'webinar2_date_time';
export const CYCLE = 'cycle';
export const EXTRA_USER_INFO_BASED_ON_PRODUCT =
  'extra_info_based_on_product_config';
export const SPOT_REGISTERED_DAY = 'spot_registered_day';
export const WHATSAPP_CONSENT = 'whats_app_consent';
export const UTM_CAMPAIGN = 'utm_campaign';
export const UTM_SOURCE = 'utm_source';
export const UTM_MEDIUM = 'utm_medium';
export const UTM_TERM = 'utm_term';
export const UTM_CONTENT = 'utm_content';
export const SC_ID = 'sc_id';
export const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const SOCIAL_MEDIA_INTENSIVE_WEBINAR_DATE_TIME =
  'social_media_intensive_webinar_date_time';
export const FORM_SELECT_FIELD_OPTION_SPECIFIC_VALUE =
  'form_select_field_option_specific_value';
export const OCCUPATION = 'occupation';
export const USER_PREFERRED_DATE = 'user_preferred_date';
export const WEBINAR_DAY = 'webinar_day';
export const FORMATTED_DATE = 'formatted_date';
export const FORMATTED_TIME = 'formatted_time';
export const PREFERRED_SLOT_AND_DATE = 'preferred_slot_and_date';
export const FORM_VALUES_DATE = 'form_values_date';
export const INTENSIVE_DEMO_PREFERRED_TIME = 'intensive_demo_preferred_time';
export const DEFAULT_VALUE = 'default_value';
export const NEW_WEBINAR_DATE_TIME = 'new_webinar_datetime';
export const FORM_VALUES_STRING = 'form_values_string';
export const BDA_LGA_FORM_WEBINAR_DATE_TIME = 'bda_lga_webinar_datetime';
export const DEFAULT = 'default';
export const DEFAULT_DATE = 'default_date';
export const SELECT = 'select';
export const FORM_VALUE = 'form_value';
